import { defineComponent as _defineComponent } from 'vue';
import { DropdownMenuPortal, DropdownMenuContent } from 'reka-ui';
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'MenuContent',
    props: {
        side: { type: null, required: false, default: 'bottom' },
        sideOffset: { type: Number, required: false, default: 4 },
        align: { type: null, required: false, default: 'start' },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        shouldKeepFocus: { type: Boolean, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        function onCloseAutoFocus(event) {
            if (!props.shouldKeepFocus) {
                event.preventDefault();
            }
        }
        const __returned__ = { props, onCloseAutoFocus, get DropdownMenuPortal() { return DropdownMenuPortal; }, get DropdownMenuContent() { return DropdownMenuContent; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
